import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ThemeIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Theme">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0.5C8.27614 0.5 8.5 0.723858 8.5 1V2.5C8.5 2.77614 8.27614 3 8 3C7.72386 3 7.5 2.77614 7.5 2.5V1C7.5 0.723858 7.72386 0.5 8 0.5Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
        <path
          id="Vector (Stroke)_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5ZM4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
        <path
          id="Vector (Stroke)_3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.64645 2.64645C2.84171 2.45118 3.15829 2.45118 3.35355 2.64645L4.35355 3.64645C4.54882 3.84171 4.54882 4.15829 4.35355 4.35355C4.15829 4.54882 3.84171 4.54882 3.64645 4.35355L2.64645 3.35355C2.45118 3.15829 2.45118 2.84171 2.64645 2.64645Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
        <path
          id="Vector (Stroke)_4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.35355 11.6464C4.54882 11.8417 4.54882 12.1583 4.35355 12.3536L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L3.64645 11.6464C3.84171 11.4512 4.15829 11.4512 4.35355 11.6464Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
        <path
          id="Vector (Stroke)_5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 8C0.5 7.72386 0.723858 7.5 1 7.5H2.5C2.77614 7.5 3 7.72386 3 8C3 8.27614 2.77614 8.5 2.5 8.5H1C0.723858 8.5 0.5 8.27614 0.5 8Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
        <path
          id="Vector (Stroke)_6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 13C8.27614 13 8.5 13.2239 8.5 13.5V15C8.5 15.2761 8.27614 15.5 8 15.5C7.72386 15.5 7.5 15.2761 7.5 15V13.5C7.5 13.2239 7.72386 13 8 13Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
        <path
          id="Vector"
          d="M8 11.5C9.933 11.5 11.5 9.933 11.5 8C11.5 6.067 9.933 4.5 8 4.5V11.5Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
      </g>
    </svg>
  );
};

export default ThemeIcon;
